'use client';
import React, { forwardRef, type PropsWithChildren } from 'react';
import {
  Carousel,
  CarouselContent,
  CarouselDots,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '../../../components/carousel';
import { cn } from '@bells/core/lib/utils';
import { type SliderProps } from './slider.props';

const Slider = forwardRef<
  HTMLDivElement,
  PropsWithChildren & {
    id: string;
    header?: React.ReactNode;
    className?: string[];
  } & Pick<SliderProps, 'hasDots'>
>(({ children, id, hasDots, header, className }, ref) => {
  return (
    <Carousel
      ref={ref}
      opts={{
        align: 'start',
        loop: true,
      }}
      className='col-span-full flex w-full flex-col gap-2 lg:gap-4'
    >
      {header && (
        <div className='flex w-full items-end lg:gap-4'>
          <div className='flex-1'>{header}</div>

          <div className='hidden items-center justify-center gap-1 lg:flex'>
            <CarouselPrevious className='relative left-0 right-0 top-0'></CarouselPrevious>
            <CarouselNext className='relative left-0 right-0 top-0'></CarouselNext>
          </div>
        </div>
      )}
      <CarouselContent className='-ml-2 max-w-full lg:-ml-4'>
        {React.Children.map(children, (child, index) => {
          return (
            <CarouselItem
              className={cn(`pl-2 lg:pl-4`, className)}
              key={`carousel-${id}-${index}`}
            >
              {child}
            </CarouselItem>
          );
        })}
      </CarouselContent>

      {hasDots && (
        <CarouselDots className='hidden lg:inline-flex'></CarouselDots>
      )}
    </Carousel>
  );
});
Slider.displayName = 'LayoutSlider';
export { Slider };
